export const QUERY_KEYS = {
  ALL_TEMPLATE_QUERY_VALIDATIONS: 'allTemplateQueryValidations',
  TEMPLATE_QUERY_VALIDATION: 'templateQueryValidation',
  ALL_IMPORTS: 'allImports',
  IMPORT: 'import',
  IMPORT_RESULT: 'importResult',
  IMPORT_MAPPING: 'importMapping',
  IMPORT_MAPPINGS: 'importMappings',
  SHAPE: 'fetchShape',
  SHAPES: 'fetchShapes',
  LIBRARY_NODE: 'libraryNode',
  LIBRARY_NODE_ARCHIVE_VALIDATION: 'libraryNodeArchiveValidation',
  TEMPLATES: 'templates',
  TEMPLATE_CHANGES: 'templateChanges',
  AVAILABLE_SHAPES: 'availableShapes',
  APPLICABLE_PATTERN: 'applicablePattern',
  APPLICABLE_PATTERNS: 'applicablePatterns',
  PATTERN: 'pattern',
  PATTERNS: 'patterns',
  PATTERN_VERSIONS: 'patternVersions',
  PATTERN_VERSION: 'patternVersion',
  PATTERN_APPLY_PREVIEW: 'applyPatternsPreview',
  PATTERN_EXTEND_OPTIONS: 'applyPatternExtendOptions',
  OVERVIEWS_SUMMARY: 'overviewsSummary',
  OVERVIEW_SPECIFICATION: 'overviewSpecification',
  DETAIL_PANEL_SPECIFICATIONS: 'detailPanelSpecifications',
  NODE_DETAIL: 'nodeDetail',
  PROJECT_TEAMS: 'projectTeams',
  INTEGRATION_CLIENTS: 'integrationClients',
  ATTACHMENTS_VALIDATION: 'attachmentsValidation',
  ALL_PROPOSALS: 'allProposals',
  PROPOSAL: 'proposal',
  PROPOSAL_CHANGES: 'proposalChanges',
  USER_SETTINGS: 'userSettings',
  OWNERSHIP_MAPPINGS: 'ownershipMappings',
  REPORT_RUNS: 'reportRuns',
  AUDIT_LOGS: 'auditLogs'
};
